import { Injectable } from '@angular/core';
import {Notification} from "./notification.interface";



@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  toasts: Notification[] = [];
  counter = 0;

  show(type: Notification['type'], title?: string, message?: string, duration = 3000) {
    const id = this.counter++;
    const toast: Notification = { id, type, title, message };
    this.toasts.push(toast);
    setTimeout(() => this.remove(id), duration);
  }
  remove(id: number) {
    this.toasts = this.toasts.filter((t) => t.id !== id);
  }
}
